import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatAngularModule } from '../../shared/modules/mat-angular.module';
import { Router, RouterModule } from '@angular/router';
import { AuthService, User } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProjectManagementService } from '../../services/project-management.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-education-dashboard',
  imports: [
    CommonModule,
    MatAngularModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './education-dashboard.component.html',
  styleUrl: './education-dashboard.component.scss',
  standalone: true,
})
export class EducationDashboardComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  snackBar = inject(MatSnackBar);
  projectService = inject(ProjectManagementService);
  http = inject(HttpClient);

  isLoading = true;
  currentUser: User | null = null;

  ngOnInit() {
    this.loadUserProfile();
  }

  private loadUserProfile() {
    this.currentUser = this.authService.getCurrentUser();
    if (!this.currentUser) {
      this.router.navigate(['/login']);
      return;
    }
    this.isLoading = false;
  }

  navigateToEducation(type: string): void {
    if (type === 'education-university') {
      this.router.navigate(['/common-ai-analysis/education/university']);
    } else if (type === 'education-student') {
      this.router.navigate(['/common-ai-analysis/education/student']);
    }
  }
}

